import React, { FC, useEffect, useRef, useState } from 'react';
import { BottomSheetRef } from 'react-spring-bottom-sheet';
import 'react-spring-bottom-sheet/dist/style.css';
import JetBottomSheet from '@src/shared/components/JetBottomSheet';
import { CourierData } from '../CourierData';
import { CourierDetailView } from '../CourierDetailView';
import { CourierDetailActionsAdd } from '../CourierDetailActionsAdd';
import { CourierDetailActionsDelete } from '../CourierDetailActionsDelete';
import { TCourier } from '../../services/api';
import { SpringEvent } from 'react-spring-bottom-sheet/dist/types';
import { CourierDetailActionsResend } from '../CourierDetailActionsResend';
import { ICourierSelectedProps } from '../CourierCard';
import CourierSettingsTips, { TRestuarantSettings } from '../CourierSettingsTips';
import CourierDetailActionsConfirm from '../CourierDetailActionsConfirm';
import DeliveryDashboardBottomSheet from '@src/pages/DeliveryDashboard/components/DeliveryDashboardBottomSheet';
import styles from './CourierBottomSheet.module.scss';

interface ICourierBottomSheet {
  //snapToPosition: () => any;
  dataObject: TCourier;
  selectedCourier?: string;
  actionType?: TBottomSheetAction;
  onBottomSheetOpen: (event: SpringEvent) => void;
  onBottomSheetClose: (event: SpringEvent, action?: EBottomSheetAction) => void;
  onButtonAction: (action: TBottomSheetAction) => void;
  onDialogsClose: () => void;
  resturantSettings: TRestuarantSettings;
}

export enum EBottomSheetAction {
  Delete = 'DELETE',
  Add = 'ADD',
  ReSend = ' RESEND',
  View = 'VIEW',
  Dismiss = 'DISMISS',
  Invite = 'INVITE',
  Send = 'SEND',
  Disconnect = 'DISCONNECT',
  Tips = 'TIPS',
  Confirm = 'CONFIRM',
  ConfirmationPending = 'CONFIRMATION_PENDING',
}

export type TBottomSheetAction = {
  type: EBottomSheetAction;
  source: ICourierSelectedProps;
};

export interface ISpringEventProps {
  type: 'OPEN' | 'CLOSE' | 'RESIZE' | 'SNAP';
  source: 'dragging' | 'custom';
}

export const CourierBottomSheet: FC<ICourierBottomSheet> = ({
  dataObject,
  actionType,
  onBottomSheetOpen,
  onBottomSheetClose,
  onButtonAction,
  onDialogsClose,
  resturantSettings,
}) => {
  // Component States
  const [bottomSheetAction, setBottomSheetAction] = useState<TBottomSheetAction>();
  const [openSheet, setOpenSheet] = useState(false);
  const [isBackdropClick, setisBackdropClick] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);
  const [bottomSheetHeight, setBottomSheetHeight] = useState<number>(0);

  //Dom Referances
  const replicaRef = React.createRef<BottomSheetRef>();

  //Event handlers
  const handleOnSprintStart = (event: SpringEvent) => {
    return onBottomSheetOpen(event);
  };

  const handleOnSpringEnd = (event: SpringEvent) => {
    return onBottomSheetClose(event, bottomSheetAction && bottomSheetAction?.type);
  };

  const handleOnDismiss = (forceToClose = false) => {
    if (!forceToClose && !isBackdropClick && bottomSheetAction?.type === EBottomSheetAction.Tips) {
      setisBackdropClick(true);
    }
    flushState();
  };

  const handleOnDelete = () => {};

  const handleOnAction = (action: TBottomSheetAction) => {
    setOpenSheet(false);
    if (
      action.type === EBottomSheetAction.Delete ||
      action.type === EBottomSheetAction.Disconnect ||
      action.type === EBottomSheetAction.ConfirmationPending
    ) {
      setTimeout(() => {
        replicaRef.current?.snapTo(227, { source: 'delete-screen' });
        setBottomSheetAction(action);
        setOpenSheet(true);
      }, 500);
    }
  };

  const flushState = () => {
    //setisBackdropClick(true);
    setOpenSheet(false);
    setBottomSheetAction(undefined as any);
    onDialogsClose();
  };

  // SideEffects
  useEffect(() => {
    if (actionType !== undefined) {
      setBottomSheetAction(actionType);
      setOpenSheet(true);
    }
    return () => {
      setOpenSheet(false), setBottomSheetAction(undefined), setisBackdropClick(false);
    };
  }, [actionType]);

  useEffect(() => {
    window.requestAnimationFrame(() => {
      let newHeight = 0;
      const newContentHeight = document.getElementById('bottom-sheet-content-container')
        ?.clientHeight as number;

      if (newContentHeight > screen.height) {
        newHeight = screen.height;
      } else {
        newHeight = newContentHeight;
      }

      setBottomSheetHeight(newHeight + 16);
    });
  }, [bottomSheetAction]);

  return (
    <>
      <DeliveryDashboardBottomSheet
        style={
          bottomSheetAction?.type === EBottomSheetAction.Delete || EBottomSheetAction.Disconnect
            ? { ['--rsbs-header' as any]: 'margin-top:8px' }
            : {}
        }
        ref={replicaRef}
        isOpen={openSheet}
        onDismiss={handleOnDismiss}
        onBottomSheetHeight={() => {}}
        onSpringStart={handleOnSprintStart}
        onSpringEnd={handleOnSpringEnd}
        skipInitialTransition={false}
        blocking={false}
        expandOnContentDrag={false}
        constantHeight={bottomSheetHeight}
        className={styles.jet_bottom_sheet_root}
      >
        <div id="bottom-sheet-content-container">
          {bottomSheetAction?.type === EBottomSheetAction.View ? (
            <CourierDetailView onDismiss={handleOnDismiss}>
              <CourierData onAction={handleOnAction} {...dataObject} />
            </CourierDetailView>
          ) : null}

          {bottomSheetAction?.type === EBottomSheetAction.ReSend ? (
            <CourierDetailView onDismiss={handleOnDismiss}>
              <CourierDetailActionsResend
                onAction={handleOnAction}
                {...dataObject}
                onDismiss={handleOnDismiss}
              />
            </CourierDetailView>
          ) : null}

          {bottomSheetAction?.type === EBottomSheetAction.Add ? (
            <CourierDetailView onDismiss={handleOnDismiss}>
              {<CourierDetailActionsAdd onActionSuccess={() => handleOnDismiss()} />}
            </CourierDetailView>
          ) : null}

          {bottomSheetAction?.type === EBottomSheetAction.Delete ||
          bottomSheetAction?.type === EBottomSheetAction.Disconnect ? (
            <CourierDetailActionsDelete
              onDismiss={handleOnDismiss}
              onAction={handleOnDelete}
              action={bottomSheetAction}
            ></CourierDetailActionsDelete>
          ) : null}

          {bottomSheetAction?.type === EBottomSheetAction.Tips ? (
            <CourierDetailView onDismiss={handleOnDismiss} viewType="tips">
              <CourierSettingsTips
                onAction={handleOnAction}
                modeConfirmPending={isBackdropClick}
                restaurantSettings={{ showTips: resturantSettings.showTips }}
                onDismiss={handleOnDismiss}
              ></CourierSettingsTips>
            </CourierDetailView>
          ) : null}

          {bottomSheetAction?.type === EBottomSheetAction.ConfirmationPending ? (
            <CourierDetailActionsConfirm
              onDismiss={handleOnDismiss}
              onAction={handleOnAction}
              bottomSheetAction={bottomSheetAction}
            ></CourierDetailActionsConfirm>
          ) : null}
        </div>
      </DeliveryDashboardBottomSheet>
    </>
  );
};
